// src/services/authCodes.js
//
// Email codes for signup and SMS codes for phone verification, through the
// auth-codes Edge Function — the same one the app uses. The server hashes
// codes, caps attempts, rate-limits sends, and is the only thing that can mark
// a phone verified.
import supabase from './supabase';

async function call(action, payload) {
  const { data, error } = await supabase.functions.invoke('auth-codes', {
    body: { action, ...payload },
  });

  if (error) {
    let message = 'Something went wrong. Please try again.';
    let code;
    try {
      const body = await error.context?.json?.();
      if (body?.error) message = body.error;
      code = body?.code;
    } catch {
      // Keep the generic message.
    }
    const err = new Error(message);
    err.code = code;
    throw err;
  }
  return data;
}

export const sendSignupEmailCode = (email) => call('signup_email_send', { email });

export const verifySignupEmailCode = async (email, code) =>
  (await call('signup_email_verify', { email, code })).signup_token;

export const completeEmailSignup = ({ email, signupToken, username, password }) =>
  call('signup_complete', { email, signup_token: signupToken, username, password });

export const sendPhoneCode = (phone) => call('phone_send', { phone });

export const verifyPhoneCode = (phone, code) => call('phone_verify', { phone, code });
